export default __webpack_public_path__ + "static/media/7_Intro.6b9195db.mp4";